"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = exports.TabContent = exports.TabsAlternative = exports.useSetActiveTabOnMount = exports.useTabContext = exports.TabsProvider = exports.Tabs = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var cls = (0, BootstrapHelper_1.B)();
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { currentTabIdx: 0 };
        _this.onInitialTabChange = function () {
            _this.props.onInitialTabChange &&
                _this.props.onInitialTabChange(_this.state.currentTabIdx);
        };
        _this.afterTabChange = function (prevIdx) {
            _this.props.afterTabChange &&
                _this.props.afterTabChange(_this.state.currentTabIdx, prevIdx);
        };
        _this.setTab = function (idx) {
            _this.props.onTabClicked(idx, _this.state.currentTabIdx);
            _this.setState({
                currentTabIdx: idx
            });
        };
        _this.getTitle = function (title) {
            if (typeof title === "string") {
                return (0, jsx_runtime_1.jsx)("span", { children: title });
            }
            else if (React.isValidElement(title)) {
                return title;
            }
        };
        return _this;
    }
    Tabs.getDerivedStateFromProps = function (props, state) {
        cls.bl(props.bemClassName);
        return null;
    };
    Tabs.prototype.componentDidMount = function () {
        this.setState({
            currentTabIdx: this.props.initialTab || this.props.currTabIdx
        });
    };
    Tabs.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.initialTab !== this.props.initialTab) {
            this.afterTabChange(prevState.currentTabIdx);
        }
        if (prevProps.currTabIdx !== this.props.currTabIdx) {
            this.setState({
                currentTabIdx: this.props.currTabIdx
            });
        }
    };
    Tabs.prototype.render = function () {
        var _this = this;
        var props = this.props, state = this.state;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(cls.bem, " ").concat(props.className) }, { children: [(0, jsx_runtime_1.jsx)("ul", __assign({ className: "".concat(cls.el("menu").bem, " ").concat(props.ulClassName) }, { children: React.Children.map(this.props.children, function (x, i) {
                        if (x.props.isHidden)
                            return null;
                        var sProps = __assign({}, x.props);
                        delete sProps.title;
                        return (x && ((0, jsx_runtime_1.jsx)("li", __assign({}, sProps, { className: "".concat(cls.el("item").bem, " ").concat(props.liClassName, " ").concat(state.currentTabIdx === i
                                ? cls.el("item").mod("active").bem
                                : ""), onClick: function () {
                                _this.setTab(i);
                            } }, { children: _this.getTitle(x.props.title) }))));
                    }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(cls.el("content").bem, " ").concat(props.contentClassName) }, { children: (!props.isSeoFriendly &&
                        this.props.children[state.currentTabIdx]) ||
                        React.Children.map(this.props.children, function (child, i) {
                            return React.cloneElement(child, __assign(__assign({}, child.props), { style: {
                                    display: state.currentTabIdx === i ? "block" : "none"
                                } }));
                        }) }))] })));
    };
    Tabs.defaultProps = {
        onTabClicked: function () { },
        onInitialTabChange: function () { },
        afterTabChange: function () { },
        bemClassName: "tabs",
        ulClassName: "",
        className: "",
        contentClassName: "",
        liClassName: "",
        isSeoFriendly: false,
        currTabIdx: 0
    };
    return Tabs;
}(React.Component));
exports.Tabs = Tabs;
var TabsContext = React.createContext({
    activeTabKey: null,
    setActiveTabKey: function (tabKey) { }
});
var TabsProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(null), activeTabKey = _b[0], setActiveTabKey = _b[1];
    return ((0, jsx_runtime_1.jsx)(TabsContext.Provider, __assign({ value: { setActiveTabKey: setActiveTabKey, activeTabKey: activeTabKey } }, { children: children })));
};
exports.TabsProvider = TabsProvider;
function useTabContext() {
    return React.useContext(TabsContext);
}
exports.useTabContext = useTabContext;
function useSetActiveTabOnMount(tabKey) {
    var setActiveTabKey = React.useContext(TabsContext).setActiveTabKey;
    React.useEffect(function () {
        setActiveTabKey(tabKey);
    }, [tabKey, setActiveTabKey]);
}
exports.useSetActiveTabOnMount = useSetActiveTabOnMount;
var TabsAlternative = function (props) {
    var cls = (0, BootstrapHelper_1.B)().bl("tabs");
    var _a = useTabContext(), setActiveTabKey = _a.setActiveTabKey, activeTabKey = _a.activeTabKey;
    var history = (0, react_router_dom_1.useHistory)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(cls.bem, " ").concat(props.className || "") }, { children: (0, jsx_runtime_1.jsx)("ul", __assign({ className: "".concat(cls.el("menu").bem, " ").concat(props.ulClassName || "") }, { children: props.tabs.map(function (tab) {
                var sProps = __assign({}, tab);
                delete sProps.title;
                delete sProps.content;
                return ((0, react_1.createElement)("li", __assign({}, sProps, { key: tab.id, className: "".concat(cls.el("item").bem, " ").concat(props.liClassName, " ").concat(tab.className, " ").concat(tab.id === activeTabKey ? cls.el("item").mod("active").bem : ""), onClick: function () {
                        if (tab.href) {
                            history.push(tab.href);
                            return;
                        }
                        setActiveTabKey(tab.id);
                    } }), typeof tab.title === "string" ? ((0, jsx_runtime_1.jsx)("span", { children: tab.title })) : (tab.title)));
            }) })) })));
};
exports.TabsAlternative = TabsAlternative;
var TabContent = function (_a) {
    var tabId = _a.tabId, children = _a.children;
    useSetActiveTabOnMount(tabId);
    return children;
};
exports.TabContent = TabContent;
var Tab = function (props) {
    if (props.isHidden)
        return null;
    var sProps = __assign({}, props);
    delete sProps.title;
    delete sProps.isHidden;
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, sProps, { className: "tab-panel ".concat(props.className), style: props.style, "data-tab-title": props.title, onClick: props.onClick }, { children: props.children })));
};
exports.Tab = Tab;
